import HttpService from "../services/Http.Service";

async function getRoom(data) {
    return await HttpService.controlServerWithToken("GET", "room", "get_room", data);
}

async function getAuthorizedRoomsByAccount(data) {
    return await HttpService.controlServerWithToken("GET", "room", "get_authorized_rooms_by_account", data);
}

async function createRoom(data) {
    return await HttpService.controlServerWithToken("POST", "room", "create_room", data);
}

async function updateRoom(data) {
    return await HttpService.controlServerWithToken("POST", "room", "update_room", data);
}

async function deleteRoom(data) {
    return await HttpService.controlServerWithToken("POST", "room", "delete_room", data);
}

export { getRoom, getAuthorizedRoomsByAccount, createRoom, updateRoom, deleteRoom };
